import React from "react";
import ReactSchema from "react-schema";
import R from "ramda";

export function newModelWith(values, defaultValues, schema) {
    validateModel(schema, defaultValues);
    validateModel(schema, values);

    return Object.assign(defaultValues, values);
}

function validateModel(schema, model) {
    const schemaValidation = ReactSchema.validate(schema, model);
    if (schemaValidation.isValid === false) {
        const errors = R.values(schemaValidation.errors).join("\n");
        throw new Error(errors);
    }

    const unexpectedProperties = R.difference(Object.keys(model), Object.keys(schema));
    if (unexpectedProperties.length !== 0) {
        throw new Error("Unexpected property: " + unexpectedProperties);
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/common/models.js
 **/